import { Box, Link, styled, Typography } from '@mui/material';

export const LeftContainer = styled(Box)(({ theme }) => ({
  width: '40%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const PincodeSectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.secondary.main,
  marginBottom: '6px',
}));

export const PincodeSectionRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

export const PincodeSectionValue = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  letterSpacing: '4px',
  color: theme.palette.secondary.dark,
}));

export const PincodeSectionMuted = styled(Typography)(() => ({
  fontSize: 14,
  color: '#6B6B6B',
}));

// Cast restores Link's polymorphic `component` prop, which `styled()` otherwise collapses.
export const PincodeSectionLink = styled(Link)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.primary.main,
  cursor: 'pointer',
})) as typeof Link;

export const PincodeChooseHeading = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 'bold',
  color: theme.palette.secondary.contrastText,
  margin: '16px 0',
}));
